import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import PatientInfo from '../PatientInfo';
import { isMobile } from '../../../../utils/mobile';

export default function HeadRow({ patient, patients, setPatient, user, headerLabel, hideSelect }) {
  // Mobile version - show only PatientInfo
  if (isMobile()) {
    return (
      <Container className="user-cabinet-navigation">
        <Row className="user-cabinet-header-row">
          {!hideSelect && (
            <PatientInfo
              wrapperStyle={{ md: 12}}
              patient={patient}
              patients={patients}
              setPatient={setPatient}
              user={user}
            />
          )}
        </Row>
      </Container>
    );
  }

  // Desktop version - show full layout
  return (
    <Container className="user-cabinet-navigation">
      <Row className="user-cabinet-header-row">
        {/* <Col md={4}>
          <NavLink className="back-to-home" to="/">
            <i className="fas fa-arrow-left"></i> На головну
          </NavLink>
        </Col> */}
        <Col md={4}>
          <div className="user-cabinet-navigation-title">{headerLabel}</div>
        </Col>
        <Col md={4} className="d-flex justify-content-center mb-2">
          <NavLink className="btn btn-primary appointment-button" to={`/`}>
            Записатись на прийом до лікаря
          </NavLink>
        </Col>
        {!hideSelect && (
          <PatientInfo
            wrapperStyle={{ md: 4}}
            patient={patient}
            patients={patients}
            setPatient={setPatient}
            user={user}
          />
        )}
      </Row>
    </Container>
  );
}
